import React, { JSX } from 'react';
import Styles from './GenericPopup.module.scss';
import GenericModal from '../NewLineCheck/GenericModal';
import FalconButtonV2 from '../FalconButtonV2/FalconButtonV2';
import FalconDescription, {
  FalconDescriptionInterface
} from '../FalconDescription/FalconDescription';
import { FalconButtonSchema, GenericSBProps } from '../types';

export interface TeleSalesErrorModalSchema extends GenericSBProps {
  heading: string;
  body: FalconDescriptionInterface[];
  primaryButton: FalconButtonSchema[];
  secondaryButton: FalconButtonSchema[];
  primaryButtonType?: string;
  secondaryButtonType?: string;
}

interface GenericPopuProps {
  modalState: boolean;
  onCloseHandler: () => void;
  content?: TeleSalesErrorModalSchema;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  wafIdentifier?: string;
}

const GenericPopu = ({
  modalState,
  onCloseHandler,
  content,
  onPrimaryClick,
  onSecondaryClick,
  wafIdentifier = ''
}: GenericPopuProps): JSX.Element => {
  return (
    <GenericModal
      modalState={modalState}
      handler={onCloseHandler}
      showFooter={false}
      width='624px'
      height='auto'
      backDrop={true}
    >
      <div className={Styles.content}>
        {content?.heading && <div className={Styles.heading}>{content.heading}</div>}
        {content?.body?.map((item) => (
          <FalconDescription content={item} key={item._uid} />
        ))}
        {(content?.secondaryButton?.length || content?.primaryButton?.length) ? (
          <div className={Styles.buttons}>
            {content?.secondaryButton?.length ? (
              <FalconButtonV2
                content={content.secondaryButton[0]}
                onClick={() => (onSecondaryClick ? onSecondaryClick() : onCloseHandler())}
                metadata={undefined}
                wafIdentifier={wafIdentifier}
              />
            ) : null}
            {content?.primaryButton?.length ? (
              <FalconButtonV2
                content={content.primaryButton[0]}
                onClick={() => (onPrimaryClick ? onPrimaryClick() : onCloseHandler())}
                metadata={undefined}
                wafIdentifier={wafIdentifier}
              />
            ) : null}
          </div>
        ) : null}
      </div>
    </GenericModal>
  );
};

export default GenericPopu;
